import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  THIRTEEN_MONTHS_DAYS,
  getStoredItem,
  removeExpiredStoredItems,
  setStoredItem,
} from "@libertify.frontend/helpers";

const LANGUAGE_KEY = "i18nextLng";

// Language is stored as `{ value, expires }` (13 months, renewed on write).
const detector = new LanguageDetector();
detector.addDetector({
  name: "expiringLocalStorage",
  lookup: () => getStoredItem(LANGUAGE_KEY) ?? undefined,
  cacheUserLanguage: (lng: string) =>
    setStoredItem(LANGUAGE_KEY, lng, THIRTEEN_MONTHS_DAYS),
});

// Drop expired entries that were never read again.
removeExpiredStoredItems([LANGUAGE_KEY, "colorMode", "mfa-setup-dismissed"]);

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init<object>({
    ns: ["common", "page-titles", "project-prompt-templates", "translation"],
    returnEmptyString: true,
    supportedLngs: ["en", "fr", "es"],
    defaultNS: "common",
    fallbackLng: ["en"],
    ignoreJSONStructure: true,
    load: "all",
    detection: {
      order: ["expiringLocalStorage", "navigator"],
      caches: ["expiringLocalStorage"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
      // React already escapes values before rendering, so i18next must NOT
      // escape interpolated values — otherwise characters like ' and & in
      // dynamic data get turned into &#39; / &amp; and shown literally.
      escapeValue: false,
    },
    // react: {
    //   useSuspense: false,
    // },
  });

export default i18n;
export const t = i18n.t.bind(i18n);
